import { useProjects } from "@/context/ProjectContext";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

// Only needed when the investor owns houses in more than one project and no project is pre-selected.
export const DisbursementProjectField = ({ investor, value, onChange, fixedProjectId }) => {
  const { projects = [] } = useProjects();
  const ids = investor?.project_ids || [];
  if (fixedProjectId || ids.length < 2) return null;
  return (
    <div>
      <Label>Proyek</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid="disbursement-project"><SelectValue placeholder="Pilih proyek" /></SelectTrigger>
        <SelectContent>
          {ids.map((id) => <SelectItem key={id} value={id}>{projects.find((p) => p.id === id)?.name || id}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};
